import {
  deleteRecipeWithImage as coreDeleteRecipeWithImage,
  removeRecipeImageByUrl as coreRemoveRecipeImageByUrl,
} from "@reciperoll/core";
import type { AppDispatch } from "@reciperoll/core";
import { supabase } from "../lib/supabase";

// Web binding for the shared delete op — injects the web Supabase client.
export function deleteRecipeWithImage(
  dispatch: AppDispatch,
  recipeId: string,
  userId?: string,
  imageUrl?: string | null,
): void {
  coreDeleteRecipeWithImage(dispatch, supabase, recipeId, userId, imageUrl);
}

// Web binding: best-effort remove a re-hosted image from Storage by its URL (for
// cleaning up a cancelled new-recipe draft, once web has an import/new flow).
export function removeRecipeImageByUrl(imageUrl?: string | null): void {
  coreRemoveRecipeImageByUrl(supabase, imageUrl);
}
